// v19 Demo Seed (自动生成 · prebuild 时 npm run seed:demo 触发)
// 1812812 真实订单数据 + 90 员工 (50 工人) + 8 客户
// 部署到 staging 时 idb-migration.service 检测无数据则 seed 一次

export const DEMO_EMPLOYEES = [
  {
    "code": "GM01",
    "name_cn": "朱杰",
    "name_vi": "Chu Kiệt",
    "role": "gm",
    "dept": "总经办",
    "password": "TN-GM-26"
  },
  {
    "code": "GM02",
    "name_cn": "副总",
    "name_vi": "Phó TGĐ",
    "role": "admin",
    "dept": "总经办",
    "password": "Trungnam2026!"
  },
  {
    "code": "SALES-01",
    "name_cn": "销售1",
    "name_vi": "KD1",
    "role": "sales",
    "dept": "销售部",
    "password": "Trungnam2026!"
  },
  {
    "code": "SALES-02",
    "name_cn": "销售2",
    "name_vi": "KD2",
    "role": "sales",
    "dept": "销售部",
    "password": "Trungnam2026!"
  },
  {
    "code": "SALES-03",
    "name_cn": "销售3",
    "name_vi": "KD3",
    "role": "sales",
    "dept": "销售部",
    "password": "Trungnam2026!"
  },
  {
    "code": "SALES-04",
    "name_cn": "销售4",
    "name_vi": "KD4",
    "role": "sales",
    "dept": "销售部",
    "password": "Trungnam2026!"
  },
  {
    "code": "SALES-05",
    "name_cn": "销售5",
    "name_vi": "KD5",
    "role": "sales",
    "dept": "销售部",
    "password": "Trungnam2026!"
  },
  {
    "code": "SALES-06",
    "name_cn": "销售6",
    "name_vi": "KD6",
    "role": "sales",
    "dept": "销售部",
    "password": "Trungnam2026!"
  },
  {
    "code": "SALES-07",
    "name_cn": "销售7",
    "name_vi": "KD7",
    "role": "sales",
    "dept": "销售部",
    "password": "Trungnam2026!"
  },
  {
    "code": "SALES-08",
    "name_cn": "销售8",
    "name_vi": "KD8",
    "role": "sales",
    "dept": "销售部",
    "password": "Trungnam2026!"
  },
  {
    "code": "SALES-09",
    "name_cn": "销售9",
    "name_vi": "KD9",
    "role": "sales",
    "dept": "销售部",
    "password": "Trungnam2026!"
  },
  {
    "code": "SALES-10",
    "name_cn": "销售10",
    "name_vi": "KD10",
    "role": "sales",
    "dept": "销售部",
    "password": "Trungnam2026!"
  },
  {
    "code": "ENG-01",
    "name_cn": "工程主管",
    "name_vi": "Trưởng KT",
    "role": "engineer",
    "dept": "工程部",
    "password": "Trungnam2026!"
  },
  {
    "code": "ENG-02",
    "name_cn": "工艺工程师",
    "name_vi": "KS công nghệ",
    "role": "engineer",
    "dept": "工程部",
    "password": "Trungnam2026!"
  },
  {
    "code": "ENG-03",
    "name_cn": "产品工程师",
    "name_vi": "KS sản phẩm",
    "role": "engineer",
    "dept": "工程部",
    "password": "Trungnam2026!"
  },
  {
    "code": "FIN-01",
    "name_cn": "财务主管",
    "name_vi": "Trưởng TC",
    "role": "finance",
    "dept": "财务部",
    "password": "Trungnam2026!"
  },
  {
    "code": "FIN-02",
    "name_cn": "出纳",
    "name_vi": "Thủ quỹ",
    "role": "finance",
    "dept": "财务部",
    "password": "Trungnam2026!"
  },
  {
    "code": "HR-01",
    "name_cn": "人事主管",
    "name_vi": "Trưởng NS",
    "role": "hr",
    "dept": "人事部",
    "password": "Trungnam2026!"
  },
  {
    "code": "HR-02",
    "name_cn": "工资专员",
    "name_vi": "CV lương",
    "role": "hr",
    "dept": "人事部",
    "password": "Trungnam2026!"
  },
  {
    "code": "WH-01",
    "name_cn": "仓储主管",
    "name_vi": "Trưởng kho",
    "role": "warehouse",
    "dept": "仓储部",
    "password": "Trungnam2026!"
  },
  {
    "code": "WH-02",
    "name_cn": "原料仓管",
    "name_vi": "TK NVL",
    "role": "warehouse",
    "dept": "仓储部",
    "password": "Trungnam2026!"
  },
  {
    "code": "WH-03",
    "name_cn": "成品仓管",
    "name_vi": "TK TP",
    "role": "warehouse",
    "dept": "仓储部",
    "password": "Trungnam2026!"
  },
  {
    "code": "WH-04",
    "name_cn": "物流调度",
    "name_vi": "Điều phối",
    "role": "warehouse",
    "dept": "仓储部",
    "password": "Trungnam2026!"
  },
  {
    "code": "PUR-01",
    "name_cn": "采购主管",
    "name_vi": "Trưởng MH",
    "role": "purchasing",
    "dept": "采购部",
    "password": "Trungnam2026!"
  },
  {
    "code": "PUR-02",
    "name_cn": "采购员-内贸",
    "name_vi": "NV nội thương",
    "role": "purchasing",
    "dept": "采购部",
    "password": "Trungnam2026!"
  },
  {
    "code": "PUR-03",
    "name_cn": "采购员-进口",
    "name_vi": "NV nhập khẩu",
    "role": "purchasing",
    "dept": "采购部",
    "password": "Trungnam2026!"
  },
  {
    "code": "QC-01",
    "name_cn": "品控主管",
    "name_vi": "Trưởng QC",
    "role": "quality",
    "dept": "品控部",
    "password": "Trungnam2026!"
  },
  {
    "code": "QC-02",
    "name_cn": "IQC检验员",
    "name_vi": "NV IQC",
    "role": "quality",
    "dept": "品控部",
    "password": "Trungnam2026!"
  },
  {
    "code": "QC-03",
    "name_cn": "OQC检验员",
    "name_vi": "NV OQC",
    "role": "quality",
    "dept": "品控部",
    "password": "Trungnam2026!"
  },
  {
    "code": "MAINT-01",
    "name_cn": "维修主管",
    "name_vi": "Trưởng BT",
    "role": "maintenance",
    "dept": "维修部",
    "password": "Trungnam2026!"
  },
  {
    "code": "MAINT-02",
    "name_cn": "机修工程师",
    "name_vi": "KS cơ khí",
    "role": "maintenance",
    "dept": "维修部",
    "password": "Trungnam2026!"
  },
  {
    "code": "MAINT-03",
    "name_cn": "电气工程师",
    "name_vi": "KS điện",
    "role": "maintenance",
    "dept": "维修部",
    "password": "Trungnam2026!"
  },
  {
    "code": "SUP-01",
    "name_cn": "印刷班长",
    "name_vi": "Tổ trưởng in",
    "role": "supervisor",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "SUP-02",
    "name_cn": "模切班长",
    "name_vi": "Tổ trưởng cắt",
    "role": "supervisor",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "SUP-03",
    "name_cn": "糊盒班长",
    "name_vi": "Tổ trưởng dán",
    "role": "supervisor",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-001",
    "name_cn": "工人1",
    "name_vi": "CN1",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-002",
    "name_cn": "工人2",
    "name_vi": "CN2",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-003",
    "name_cn": "工人3",
    "name_vi": "CN3",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-004",
    "name_cn": "工人4",
    "name_vi": "CN4",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-005",
    "name_cn": "工人5",
    "name_vi": "CN5",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-006",
    "name_cn": "工人6",
    "name_vi": "CN6",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-007",
    "name_cn": "工人7",
    "name_vi": "CN7",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-008",
    "name_cn": "工人8",
    "name_vi": "CN8",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-009",
    "name_cn": "工人9",
    "name_vi": "CN9",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-010",
    "name_cn": "工人10",
    "name_vi": "CN10",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-011",
    "name_cn": "工人11",
    "name_vi": "CN11",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-012",
    "name_cn": "工人12",
    "name_vi": "CN12",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-013",
    "name_cn": "工人13",
    "name_vi": "CN13",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-014",
    "name_cn": "工人14",
    "name_vi": "CN14",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-015",
    "name_cn": "工人15",
    "name_vi": "CN15",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-016",
    "name_cn": "工人16",
    "name_vi": "CN16",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-017",
    "name_cn": "工人17",
    "name_vi": "CN17",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-018",
    "name_cn": "工人18",
    "name_vi": "CN18",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-019",
    "name_cn": "工人19",
    "name_vi": "CN19",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-020",
    "name_cn": "工人20",
    "name_vi": "CN20",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-021",
    "name_cn": "工人21",
    "name_vi": "CN21",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-022",
    "name_cn": "工人22",
    "name_vi": "CN22",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-023",
    "name_cn": "工人23",
    "name_vi": "CN23",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-024",
    "name_cn": "工人24",
    "name_vi": "CN24",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-025",
    "name_cn": "工人25",
    "name_vi": "CN25",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-026",
    "name_cn": "工人26",
    "name_vi": "CN26",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-027",
    "name_cn": "工人27",
    "name_vi": "CN27",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-028",
    "name_cn": "工人28",
    "name_vi": "CN28",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-029",
    "name_cn": "工人29",
    "name_vi": "CN29",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-030",
    "name_cn": "工人30",
    "name_vi": "CN30",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-031",
    "name_cn": "工人31",
    "name_vi": "CN31",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-032",
    "name_cn": "工人32",
    "name_vi": "CN32",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-033",
    "name_cn": "工人33",
    "name_vi": "CN33",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-034",
    "name_cn": "工人34",
    "name_vi": "CN34",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-035",
    "name_cn": "工人35",
    "name_vi": "CN35",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-036",
    "name_cn": "工人36",
    "name_vi": "CN36",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-037",
    "name_cn": "工人37",
    "name_vi": "CN37",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-038",
    "name_cn": "工人38",
    "name_vi": "CN38",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-039",
    "name_cn": "工人39",
    "name_vi": "CN39",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-040",
    "name_cn": "工人40",
    "name_vi": "CN40",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-041",
    "name_cn": "工人41",
    "name_vi": "CN41",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-042",
    "name_cn": "工人42",
    "name_vi": "CN42",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-043",
    "name_cn": "工人43",
    "name_vi": "CN43",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-044",
    "name_cn": "工人44",
    "name_vi": "CN44",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-045",
    "name_cn": "工人45",
    "name_vi": "CN45",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-046",
    "name_cn": "工人46",
    "name_vi": "CN46",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-047",
    "name_cn": "工人47",
    "name_vi": "CN47",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-048",
    "name_cn": "工人48",
    "name_vi": "CN48",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-049",
    "name_cn": "工人49",
    "name_vi": "CN49",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "W-050",
    "name_cn": "工人50",
    "name_vi": "CN50",
    "role": "worker",
    "dept": "生产部",
    "password": "Trungnam2026!"
  },
  {
    "code": "GUARD-01",
    "name_cn": "门卫",
    "name_vi": "Bảo vệ",
    "role": "guard",
    "dept": "行政部",
    "password": "Trungnam2026!"
  }
]

export const DEMO_CUSTOMERS = [
  {
    "code": "C001",
    "name_cn": "明点",
    "name_vi": "Mingdian",
    "credit": 50000000,
    "terms": "NET60",
    "country": "VN"
  },
  {
    "code": "C002",
    "name_cn": "正秋",
    "name_vi": "Zhengqiu",
    "credit": 30000000,
    "terms": "NET30",
    "country": "VN"
  },
  {
    "code": "C003",
    "name_cn": "Foremost (终端)",
    "name_vi": "Foremost",
    "credit": 100000000,
    "terms": "NET60",
    "country": "US"
  },
  {
    "code": "C004",
    "name_cn": "Costco",
    "name_vi": "Costco",
    "credit": 200000000,
    "terms": "NET60",
    "country": "US"
  },
  {
    "code": "C005",
    "name_cn": "Walmart",
    "name_vi": "Walmart",
    "credit": 150000000,
    "terms": "NET60",
    "country": "US"
  },
  {
    "code": "C006",
    "name_cn": "IKEA",
    "name_vi": "IKEA",
    "credit": 80000000,
    "terms": "NET45",
    "country": "SE"
  },
  {
    "code": "C007",
    "name_cn": "本地客户A",
    "name_vi": "KH địa phương A",
    "credit": 20000000,
    "terms": "NET30",
    "country": "VN"
  },
  {
    "code": "C008",
    "name_cn": "本地客户B",
    "name_vi": "KH địa phương B",
    "credit": 15000000,
    "terms": "NET30",
    "country": "VN"
  }
]

export const DEMO_PRODUCTS_1812812 = [
  {
    "code": "PRD019-1812812",
    "name_cn": "1812812主箱",
    "name_vi": "Thùng chính 1812812",
    "length": 480,
    "width": 320,
    "height": 280,
    "unit_price": 128619
  },
  {
    "code": "PRD020-1812812",
    "name_cn": "1812812纸板",
    "name_vi": "Tấm carton 1812812",
    "length": 480,
    "width": 320,
    "height": 0,
    "unit_price": 12500
  },
  {
    "code": "PRD021-1812812",
    "name_cn": "1812812侧封箱",
    "name_vi": "Hộp bên 1812812",
    "length": 480,
    "width": 165,
    "height": 140,
    "unit_price": 45000
  }
]

export const DEMO_SALES_ORDER_1812812 = {
  code: 'SO-2026-1812812',
  customer_code: 'C001',
  terminal_brand: 'Foremost',
  total_amount: 1286000000,
  status: 'completed',
  qty: 10000,
  unit_price_avg: 128619,
  delivery_date: '2026-04-22',
  notes: '1812812 真实订单 · Mingdian → Foremost Costco'
}

export const DEMO_SALES_ORDER_1812800 = {
  code: 'SO-2026-1812800',
  customer_code: 'C001',
  total_amount: 2040190000, // 19.43 亿 (调价 +5% 后)
  qty: 10500,
  unit_price_avg: 194304, // 原 185051 +5%
  status: 'completed',
  notes: '1812800 +5% 调价后订单'
}

export const DEMO_BANK = {
  vnd_account: '6521295397',
  usd_account: '6520012144',
  swift: 'BIDVVNVX',
  bank_name_cn: 'BIDV 美福分行',
  bank_name_en: 'BIDV My Phuoc Branch'
}

export const SEED_STATS = {
  employees: 86,
  workers: 50,
  customers: 8,
  products_1812812: 3,
  total_orders_value_vnd: 3326190000 // 1286 + 2040 = 3326 亿
}
